<div class="change-password-wrapper">
  <div class="card">
    <h2>Reset Password</h2>

    <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">

      <!-- New Password -->
      <div class="form-group">
        <label>New Password</label>

        <div style="position: relative;">
          <input
            [type]="showPassword ? 'text' : 'password'"
            formControlName="password"
          />

          <img
            [src]="showPassword 
              ? 'assets/images/hide_password.svg' 
              : 'assets/images/show_password.svg'"
            (click)="togglePassword()"
            alt="toggle password"
            style="
              position: absolute;
              right: 12px;
              top: 50%;
              transform: translateY(-50%);
              cursor: pointer;
              width: 18px;
              height: 18px;
            "
          />
        </div>

        <small *ngIf="submitted && f.password?.errors?.minlength">
          Password must be at least 6 characters
        </small>
      </div>

      <!-- Confirm Password -->
      <div class="form-group">
        <label>Confirm Password</label>

        <div style="position: relative;">
          <input
            [type]="showConfirmPassword ? 'text' : 'password'"
            formControlName="confirm_password"
          />

          <img
            [src]="showConfirmPassword 
              ? 'assets/images/hide_password.svg' 
              : 'assets/images/show_password.svg'"
            (click)="toggleConfirmPassword()"
            alt="toggle password"
            style="
              position: absolute;
              right: 12px;
              top: 50%;
              transform: translateY(-50%);
              cursor: pointer;
              width: 18px;
              height: 18px;
            "
          />
        </div>

        <small *ngIf="submitted && f.confirm_password?.errors?.required">
          Confirm password is required
        </small>

        <small *ngIf="submitted && f.confirm_password?.errors?.mismatch">
          Password and Confirm Password must match
        </small>
      </div>

      <button type="submit" class="btn-submit">
        Reset
      </button>

    </form>
  </div>
</div>
